import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "card border-0 shadow-none rounded-3 mb-4"
}
const _hoisted_3 = { class: "card-body p-4 p-xl-40 text-center text-optional" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_SystemSettings = _resolveComponent("SystemSettings")!
  const _component_CustomerDisplaySettings = _resolveComponent("CustomerDisplaySettings")!
  const _component_PosReceiptSettings = _resolveComponent("PosReceiptSettings")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, { pageTitle: "system_settings" }),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("system_settings_page.loading_settings")), 1)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_SystemSettings, {
              settings: _ctx.settings,
              customers: _ctx.customers,
              warehouses: _ctx.warehouses,
              "logo-url": _ctx.logoUrl,
              "is-saving": _ctx.isSaving,
              "onUpdate:settings": _ctx.updateSettings,
              onLogoChange: _ctx.handleLogoChange,
              onSubmit: _ctx.saveSettings
            }, null, 8, ["settings", "customers", "warehouses", "logo-url", "is-saving", "onUpdate:settings", "onLogoChange", "onSubmit"]),
            _createVNode(_component_CustomerDisplaySettings, {
              settings: _ctx.settings,
              "is-saving": _ctx.isSaving,
              "onUpdate:settings": _ctx.updateSettings,
              onPosterImageChange: _ctx.handlePosterImageChange,
              onSubmit: _ctx.saveSettings
            }, null, 8, ["settings", "is-saving", "onUpdate:settings", "onPosterImageChange", "onSubmit"]),
            _createVNode(_component_PosReceiptSettings, {
              settings: _ctx.settings,
              "onUpdate:settings": _ctx.updateSettings
            }, null, 8, ["settings", "onUpdate:settings"])
          ], 64)),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ])
  ], 64))
}